import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardReadReceiptOption')(function discardReadReceiptOption(state) {
    var optionState = state.optionState;
    optionState.readReceiptResponse = null;
}));
//# sourceMappingURL=discardReadReceiptOption.js.map